import {GET_VEHICLE_DETAILS_SUCCESS} from "../../reducers/vehicleReducer";


export const getVehicleDetailsSuccess = (vehicleDetails) =>{
    return {
        type: GET_VEHICLE_DETAILS_SUCCESS,
        payload: {vehicleDetails, stateMachineLogs: vehicleDetails.stateMachineLogs}
    }
}